import { UseCase } from "../../useCase"
import { DownloadTournamentMembersResponse } from "./response"
import { DownloadTournamentMembersRequest } from "./request"
import { SellerServicesRepository } from "../../../repositories/sellerServicesRepository"

export class DownloadTournamentMembersUseCase
	implements UseCase<DownloadTournamentMembersRequest, DownloadTournamentMembersResponse>
{
	private _repository
	constructor({ SellerServicesRepository }: { SellerServicesRepository: SellerServicesRepository }) {
		this._repository = SellerServicesRepository
	}

	exec({ serviceId }: DownloadTournamentMembersRequest) {
		return this._repository.downloadTournamentMembers(serviceId)
	}
}
